import ReportForm from "../components/ReportForm";

export default function ReportRoute() {
  return <ReportForm />;
}
